import { TypoCallout } from '@/components/Typography.tsx';

const WinTheGame = () => (
  <section id="about-section" className="bg-common-white text-[#151012] py-24 px-4 text-center">
    <h3 className="font-primary text-title md:text-heroTitle">
      <strong className="font-extraBold">How to win</strong> the
      <strong className="text-primary font-extraBold"> GAME</strong>!
    </h3>
    <strong className="block font-primary text-body font-bold md:text-heroSubtitle text-[#6F6F6F] mb-11">
        All it takes to succeed on the digital SAT is:
    </strong>

    <div className="flex flex-wrap justify-center mx-auto max-w-xl gap-2 md:gap-4">
      {SUCCESS_ITEMS.map((item) => <RectTag key={item} title={item} />)}
    </div>

    <TypoCallout className="block mt-5 md:mt-20 mb-5 mx-auto max-w-lg px-3.5 md:text-body">
        You supply the time, determination, patience, and discipline. <br/>
      <strong>We will supply the game plan, organization, and background support</strong>.
    </TypoCallout>
  </section>
);

const RectTag = ({ title }: { title: string }) => (
  <div className="inline-block bg-neutral3 rounded-xl -skew-x-12 px-4 md:px-8 py-2 md:py-5">
    <span className="block skew-x-12 text-common-white text-callout md:text-[1.125rem] font-primary font-bold">
      {title}
    </span>
  </div>
);

const SUCCESS_ITEMS = [
  'Time',
  'Determination',
  'Patience',
  'Discipline',
  'A GAME plan',
  'Organization',
  'A bit of background support'
];

export default WinTheGame;
